import React from "react";
import { useNavigate } from "react-router-dom";
import { Menu, MenuItem, Link } from "@aws-amplify/ui-react";
import { FaLanguage, FaCircleCheck } from "react-icons/fa6";
import { CookieStorage, I18n } from "aws-amplify/utils";

import { languages } from "../i18n";

const LanguageMenu: React.FC = () => {
  const navigate = useNavigate();

  const [lang, setLang] = React.useState<string>(
    import.meta.env.VITE_DEFAULT_LANG ?? "en"
  );

  const setLanguage = (language: string) => {
    const cookieStorage = new CookieStorage();
    cookieStorage.setItem("language", language).then(() => {
      I18n.setLanguage(language);
      navigate(0);
    });
  };

  React.useEffect(() => {
    const cookieStorage = new CookieStorage();
    cookieStorage.getItem("language").then((language: string | null) => {
      I18n.setLanguage(language ?? import.meta.env.VITE_DEFAULT_LANG ?? "en");
      setLang(language ?? import.meta.env.VITE_DEFAULT_LANG ?? "en");
    });
  }, []);

  return (
    <Menu
      trigger={
        <Link>
          <FaLanguage size="24" aria-label={I18n.get("Language")} />
        </Link>
      }
    >
      {Object.values(languages).map((language) => (
        <MenuItem
          key={language.code}
          onClick={() => setLanguage(language.code)}
        >
          {language.name}&nbsp;
          {lang === language.code ? (
            <FaCircleCheck aria-label={I18n.get("Selected")} />
          ) : (
            ""
          )}
        </MenuItem>
      ))}
    </Menu>
  );
};

export default LanguageMenu;
